<template>
    <v-flex class="fill-height">
        <div class="pl-3 py-3">
            <div class="subheading font-weight-bold">
                {{ column.title }}
            </div>
            <small class="grey--text text--darken-2 text-no-wrap pr-2">
                ({{ column.total }} resultat<span v-if="column.total !== 1">er</span>
                <span v-if="showArchived">, <span class="red--text">inkl. arkiverte</span></span>)
            </small>
        </div>
        <v-divider light/>
        <v-list light three-line class="search-bar-column-list fill-height">
            <v-list-item v-for="result in column.results" :to="result.to" @click="resetAndHideResults"
                         :key="result.id" :class="result.is_deleted ? 'red lighten-4' : null">
                <v-list-item-content>
                    <v-list-item-title>
                        {{ result.title }}
                        <small class="red--text float-right font-weight-bold" v-if="result.is_deleted">Arkivert</small>
                    </v-list-item-title>
                    <v-list-item-subtitle class="text--primary">{{ result.subtitle }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>{{ result.description }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="result.location">
                    <v-chip label color="secondary" class="white--text">{{ result.location }}</v-chip>
                </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="column.results.length === 0">
                <v-list-item-content>
                    <v-list-item-subtitle class="text--grey text-center">
                        Ingen {{ column.title.toLowerCase() }} funnet.
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-flex>
</template>
<script>
    export default {
        name: 'SearchResultColumn',
        props: {
            column: {type: Object},
            resetAndHideResults: {}
        },

        computed: {
            showArchived() {
                return !!this.$route.query['is_deleted'];
            }
        }
    }
</script>
<style>
    .search-bar-column .search-bar-column-list {
        border-right: 1px solid #dfdfdf;
        height: 100%;
    }

    .search-bar-column:last-child .search-bar-column-list {
        border-right: 0;
    }

    .search-bar-column-list {
        max-height: 60vh;
        overflow-y: scroll;
        background-color: #f2f2f2;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05) inset;
        padding-top: 0;
        padding-bottom: 0;
    }
</style>
